import axios from 'axios';

export const getContentLayouts = (bookId, pageId) => axios.get(
  '/api/content-layouts',
  { withCredentials: true, params: { book_id: bookId || undefined, page_id: pageId || undefined } },
);

export const createContentLayout = (layout) => axios.post(
  '/api/content-layouts',
  layout,
  { withCredentials: true },
);

export const updateContentLayout = (layoutId, layout) => axios.put(
  `/api/content-layouts/${layoutId}`,
  layout,
  { withCredentials: true },
);

export const deleteContentLayout = (layoutId) => axios.delete(
  `/api/content-layouts/${layoutId}`,
  { withCredentials: true },
);

export const restoreLatestContentLayout = (layoutId) => axios.post(
  `/api/content-layouts/${layoutId}/restore-latest`,
  {},
  { withCredentials: true },
);

export const getVectorLayouts = (bookId) => axios.get(
  `/api/vector-layouts?book_id=${bookId}`,
  { withCredentials: true },
);

export const connectPageVectorLayout = (pageId, layout) => axios.put(
  `/api/page/${pageId}/vector-layout`,
  {
    vector_layout_id: layout._id,
    vector_layout_name: layout.name,
  },
  { withCredentials: true },
);

export const disconnectPageVectorLayout = (pageId) => axios.delete(
  `/api/page/${pageId}/vector-layout`,
  { withCredentials: true },
);
